import {
  DRESSING_HISTORY_FAILED,
  DRESSING_HISTORY_REQUEST,
  DRESSING_HISTORY_SUCCESS,
} from "app/redux/actions/Factory/Dressing/dressingHistory/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const dressingHistoryReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case DRESSING_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case DRESSING_HISTORY_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case DRESSING_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
